import { Injectable } from '@angular/core';
import { Observable, of, from } from 'rxjs';
import { User } from '../_models/user.model';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import * as firebase from 'firebase';

@Injectable()
export class AuthService {
	constructor() {}

	login(email: string, password: string): Observable<User> {
		return from(firebase.auth().signInWithEmailAndPassword(email, password)).pipe(
			switchMap(cred => {
				if (!cred || !cred.user) {
					return of(null);
				}
				return from(cred.user.getIdToken()).pipe(
					map((token: string) => ({ token, firebaseUser: cred.user }))
				);
			}),
			map((authState: any) => {
				if (!authState) {
					return null;
				}
				const u = new User();
				u.email = email;
				u.accessToken = authState.token;
				u.pic = './assets/media/users/default.jpg';
				u.fullname = authState.firebaseUser.displayName || email;
				return u;
			}),
			tap(user => {
				if (user && user.accessToken) {
					localStorage.setItem(environment.authTokenKey, user.accessToken);
				}
			}),
			catchError(err => {
				console.error('Firebase login error', err);
				return of(null);
			})
		);
	}

	getUserByToken(): Observable<User> {
		return new Observable<User>(observer => {
			const unsubscribe = firebase.auth().onAuthStateChanged(current => {
				unsubscribe();
				if (!current) {
					observer.next(null);
					observer.complete();
					return;
				}
				current.getIdToken().then(
					(token: string) => {
						const u = new User();
						u.email = current.email;
						u.accessToken = token;
						u.fullname = current.displayName || current.email;
						observer.next(u);
						observer.complete();
					},
					err => {
						console.error('Firebase getUserByToken error', err);
						observer.next(null);
						observer.complete();
					}
				);
			});
		});
	}

	signOutUser() {
		localStorage.removeItem(environment.authTokenKey);
		firebase.auth().signOut();
	}
}
